import React from 'react';
import classNames from 'classnames';
import { Typography } from 'antd';

export default function EmptyPage({ title, description, className }: Props): JSX.Element {
  return (
    <div
      className={classNames(
        'tw-flex-1 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center',
        className
      )}
    >
      <div className="tw-m-auto">
        {title && (
          <Typography.Title
            level={3}
            className="opacity-50 tw-text-gray-600 tw-font-bold tw-text-center"
          >
            {title}
          </Typography.Title>
        )}
        <svg
          width="360"
          height="250"
          viewBox="0 0 360 250"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="tw-m-auto"
        >
          <g>
            <path
              d="M229.379 259.112C213.274 249.908 232.743 202.979 244.058 186.794C253.967 200.316 276.402 199.515 278.91 195.302C278.905 198.064 278.246 210.319 283.234 222.211C288.221 234.102 296.241 241.309 296.976 246.202C298.77 258.109 289.143 262.272 284.628 262.772C268.983 263.372 259.505 244.092 256.721 234.377C245.396 259.392 233.774 261.29 229.379 259.112Z"
              fill="#211249"
            />
            <path
              d="M269.412 173.174C280.184 172.163 289.971 164.408 293.518 160.656C297.446 156.645 296.92 145.924 263.391 135.128"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M269.478 173.186C269.011 172.229 267.655 170.403 265.741 169.968"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M265.741 169.967C266.25 167.581 269.436 161.781 278.114 157.67"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M269.078 154.678C268.528 153.246 266.607 150.065 263.33 148.796"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M258.057 172.408C256.334 171.996 252.749 171.056 252.197 170.6C251.508 170.03 251.337 169.997 251.497 169.147C251.657 168.296 258.314 171.047 258.827 168.326C258.317 167.584 257.565 165.992 258.639 165.56C259.712 165.128 261.385 167.281 262.088 168.412C262.818 169.547 264.58 171.453 265.777 169.987"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M269.263 173.109C268.071 175.204 264.542 178.702 259.961 175.937C255.38 173.171 255.357 172.163 255.919 172.005"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M235.396 164.518C234.261 163.965 231.93 161.949 231.695 158.31C231.459 154.67 232.666 154.88 233.298 155.44"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M240.318 162.841C240.31 160.843 239.706 156.875 237.345 156.994"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M239.97 159.516C241.787 158.519 242.192 161.668 242.167 163.367C243.843 164.246 244.031 166.949 243.915 168.19C239.719 167.837 237.002 166.18 235.396 164.518C234.413 163.5 233.848 162.48 233.614 161.756C233.174 159.235 232.811 154.079 234.88 153.623C236.95 153.167 237.14 155.106 236.976 156.133C236.335 158.409 237.055 161.199 237.495 162.31"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M278.538 177.258C281.146 182.638 283.283 196.355 274.713 197.564C262.636 198.783 238.858 194.989 240.353 170.064"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M230.697 160.052L204.007 153.336C202.787 153.029 201.552 153.784 201.27 155.01L198.82 165.642C198.536 166.874 197.292 167.629 196.068 167.312L189.149 165.517C187.971 165.211 187.25 164.023 187.525 162.837L188.988 156.511C189.266 155.312 188.526 154.112 187.329 153.822L185.322 153.336C184.121 153.044 182.91 153.778 182.613 154.977L181.781 158.329C181.488 159.51 180.307 160.243 179.119 159.982L176.278 159.357C175.039 159.084 174.271 157.839 174.584 156.609L176.532 148.956C176.84 147.744 176.099 146.514 174.883 146.219L170.76 145.222C169.551 144.929 168.81 143.708 169.108 142.5L171.397 133.234C171.695 132.025 172.921 131.29 174.128 131.595L203.728 139.087L276.465 157.931"
              stroke="#211249"
              strokeWidth="2.24605"
              strokeLinecap="round"
            />
            <path
              d="M248.445 134.613C247.154 133.439 236.008 132.236 236.476 118.019C232.812 117.373 231.388 114.004 234.419 113.248C237.681 112.275 237.988 109.418 237.762 107.657C237.316 105.321 237.694 103.027 237.969 102.584"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M240.638 113.635C240.222 113.562 239.974 112.997 240.084 112.374C240.194 111.75 240.62 111.304 241.036 111.377C241.452 111.45 241.7 112.015 241.59 112.639C241.48 113.263 241.054 113.709 240.638 113.635Z"
              fill="#211249"
            />
            <path
              d="M243.536 109.463C243.049 108.696 241.651 107.445 239.959 108.577"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M245.288 122.938C243.842 124.451 242.519 124.709 240.338 123.146"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M256.742 112.575C256.894 113.194 256.868 114.53 255.545 114.919"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M270.712 109.143C270.669 117.192 265.115 122.212 261.04 126.107C257.945 123.597 253.132 118.106 255.388 118.036C257.759 117.963 261.33 112.205 259.477 109.889C257.303 107.172 254.329 110.104 253.402 112.577L251.994 108.57C253.061 106.155 254.127 101.766 249.86 103.535C245.592 105.304 240.142 103.603 237.95 102.532C234.007 98.4108 228.359 89.4671 237.314 86.6604C244.762 84.3261 252.71 90.5485 257.314 95.6615C261.136 95.3863 270.772 98.1675 270.712 109.143Z"
              fill="#211249"
            />
            <path
              d="M260.885 125.537C258.867 127.208 257.74 128.699 257.199 132.125"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M260.532 137.475C261.486 135.574 262.546 131.805 259.147 131.936C254.899 132.1 245.84 134.564 246.027 136.911"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M245.435 140.055C241.936 142.252 240.941 143.893 239.876 147.121"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M62.1278 93.0908C59.5891 81.5751 57.769 56.7965 76.6677 54.0825C82.2115 53.3945 91.7454 58.5407 95.4565 75.935"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M52.9271 97.1015C52.9927 97.4046 53.2916 97.5972 53.5947 97.5316C53.8978 97.466 54.0904 97.1671 54.0248 96.864L52.9271 97.1015ZM69.1436 47.1402L68.99 46.6001L69.1436 47.1402ZM101.575 75.0483C101.644 75.3505 101.946 75.5393 102.248 75.4699C102.55 75.4004 102.739 75.0991 102.669 74.7969L101.575 75.0483ZM54.0248 96.864C52.6256 90.3983 51.4993 79.4509 53.2263 69.4283C54.9557 59.3916 59.5043 50.4661 69.2973 47.6803L68.99 46.6001C58.57 49.5643 53.8755 59.047 52.1195 69.2376C50.3612 79.4424 51.5075 90.5412 52.9271 97.1015L54.0248 96.864ZM69.2973 47.6803C74.4109 46.2256 78.7757 46.4213 82.4948 47.7029C86.219 48.9862 89.3344 51.372 91.9206 54.3565C97.1038 60.3378 100.108 68.6641 101.575 75.0483L102.669 74.7969C101.184 68.332 98.1249 59.8014 92.7693 53.621C90.0861 50.5246 86.8135 48.0032 82.8607 46.6411C78.9027 45.2772 74.3015 45.0891 68.99 46.6001L69.2973 47.6803Z"
              fill="#211249"
            />
            <path
              d="M66.0544 88.5916L90.8388 76.9022"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M50.231 96.6729C47.3157 97.7859 41.0264 101.354 39.1913 106.721"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M38.6881 106.472C45.6072 100.434 49.7226 108.686 51.3174 112.349L61.0873 164.905C63.2218 176.387 66.4315 175.22 70.2601 177.513C60.3904 176.035 54.7286 172.483 52.6446 170.621C46.9812 165.562 39.4054 122.138 38.302 117.431C37.4193 113.666 38.3387 107.87 38.6881 106.472Z"
              fill="#211249"
            />
            <path
              d="M103.904 80.0092L58.2369 103.066C53.7812 105.315 51.345 110.236 52.2572 115.143L62.1898 168.574C63.6548 176.455 72.6667 180.308 79.3759 175.922L123.916 146.804C127.71 144.324 129.641 139.808 128.812 135.352L120.007 87.9817C118.638 80.6212 110.587 76.635 103.904 80.0092Z"
              stroke="#211249"
              strokeWidth="1.12302"
              strokeLinecap="round"
            />
            <path
              d="M91.6437 117.448C95.2925 107.907 89.0165 104.704 85.4224 104.295C96.5299 100.292 96.4996 111.275 95.096 117.267L105.672 134.572L99.4896 132.957C98.83 132.785 98.2843 132.322 98.0064 131.7L91.6437 117.448Z"
              fill="#211249"
            />
            <path
              d="M88.7278 119.923L89.2889 119.943L89.309 119.382L88.748 119.362L88.7278 119.923ZM87.8872 143.361L87.326 143.341L87.2919 144.292L88.141 143.862L87.8872 143.361ZM105.216 134.579L105.47 135.08L106.002 134.811L105.701 134.296L105.216 134.579ZM95.0628 117.239L94.5337 117.051L94.4462 117.297L94.5783 117.523L95.0628 117.239ZM85.7515 103.912L85.5748 103.379L85.7515 103.912ZM88.1666 119.903L87.326 143.341L88.4483 143.381L89.2889 119.943L88.1666 119.903ZM88.141 143.862L105.47 135.08L104.963 134.079L87.6334 142.86L88.141 143.862ZM105.701 134.296L95.5474 116.955L94.5783 117.523L104.732 134.863L105.701 134.296ZM95.5919 117.427C96.5758 114.66 96.8499 110.325 95.5134 107.077C94.8386 105.437 93.7343 104.033 92.0623 103.286C90.3913 102.54 88.2468 102.493 85.5748 103.379L85.9283 104.445C88.4241 103.618 90.2644 103.713 91.6045 104.312C92.9436 104.909 93.8767 106.051 94.4748 107.504C95.6841 110.443 95.446 114.485 94.5337 117.051L95.5919 117.427ZM85.5748 103.379C83.76 103.981 82.6084 105.391 82.0121 107.096C81.4192 108.792 81.361 110.807 81.726 112.732C82.0912 114.659 82.889 116.543 84.0597 117.974C85.2332 119.408 86.8092 120.415 88.7075 120.484L88.748 119.362C87.2547 119.308 85.9569 118.519 84.9288 117.263C83.8979 116.003 83.1664 114.301 82.8294 112.523C82.4921 110.744 82.5587 108.936 83.0722 107.467C83.5822 106.008 84.5187 104.913 85.9283 104.445L85.5748 103.379Z"
              fill="#211249"
            />
            <path
              d="M250.655 58.7521C250.45 58.4917 250.073 58.4466 249.813 58.6514C249.552 58.8563 249.507 59.2335 249.712 59.494L250.655 58.7521ZM305.778 85.7461L305.848 85.1503L305.778 85.7461ZM316.037 75.6766L315.718 76.1848L316.037 75.6766ZM303.682 113.916C303.892 114.173 304.27 114.212 304.526 114.002C304.783 113.793 304.822 113.415 304.613 113.158L303.682 113.916ZM280.209 57.0394L279.862 56.5499L280.209 57.0394ZM280.945 57.4306L280.346 57.4026L280.945 57.4306ZM249.712 59.494C251.451 61.7052 255.053 64.1407 260.284 64.5521C265.524 64.9643 272.35 63.3438 280.556 57.529L279.862 56.5499C271.828 62.2435 265.274 63.7409 260.378 63.3558C255.472 62.97 252.182 60.693 250.655 58.7521L249.712 59.494ZM280.346 57.4026C280.114 62.3597 280.521 68.8967 283.982 74.556C287.463 80.2493 293.968 84.9494 305.707 86.3419L305.848 85.1503C294.399 83.7921 288.258 79.2494 285.005 73.93C281.732 68.5768 281.317 62.3314 281.544 57.4586L280.346 57.4026ZM305.707 86.3419C310.833 86.9501 315.581 85.6717 318.055 83.4817C319.304 82.3766 320.035 80.9737 319.798 79.4351C319.565 77.9182 318.417 76.4623 316.356 75.1684L315.718 76.1848C317.639 77.3904 318.455 78.5917 318.612 79.6176C318.767 80.6216 318.318 81.6469 317.26 82.5832C315.122 84.4758 310.758 85.7326 305.848 85.1503L305.707 86.3419ZM316.356 75.1684C314.886 74.2462 313.351 73.9293 311.828 74.1341C310.315 74.3374 308.852 75.0495 307.498 76.1207C304.796 78.2573 302.439 81.8891 300.835 86.1621C297.633 94.6919 297.321 106.11 303.682 113.916L304.613 113.158C298.625 105.81 298.838 94.8964 301.958 86.5838C303.515 82.4357 305.768 79.0186 308.242 77.0619C309.475 76.0866 310.741 75.4909 311.987 75.3234C313.223 75.1573 314.478 75.4064 315.718 76.1848L316.356 75.1684ZM280.556 57.529C280.508 57.5628 280.452 57.5567 280.42 57.5401C280.404 57.5315 280.385 57.5161 280.369 57.4906C280.352 57.4624 280.344 57.43 280.346 57.4026L281.544 57.4586C281.587 56.5509 280.559 56.0562 279.862 56.5499L280.556 57.529Z"
              fill="#211249"
            />
            <path
              d="M332.989 178.266C331.344 185.088 327.981 190.762 323.931 194.432C319.876 198.107 315.235 199.7 310.927 198.661C306.619 197.623 303.214 194.089 301.28 188.97C299.348 183.857 298.941 177.274 300.586 170.452C302.231 163.63 305.594 157.957 309.644 154.286C313.699 150.611 318.341 149.018 322.648 150.057C326.956 151.096 330.361 154.629 332.295 159.749C334.227 164.862 334.634 171.444 332.989 178.266Z"
              stroke="#211249"
              strokeWidth="2.24605"
            />
            <path
              d="M325.953 176.513C325.001 180.462 323.059 183.725 320.745 185.822C318.427 187.923 315.838 188.778 313.487 188.211C311.136 187.644 309.221 185.703 308.115 182.776C307.012 179.855 306.77 176.065 307.723 172.117C308.675 168.168 310.617 164.905 312.931 162.808C315.249 160.707 317.838 159.852 320.189 160.418C322.54 160.985 324.455 162.927 325.561 165.854C326.664 168.775 326.905 172.564 325.953 176.513Z"
              stroke="#211249"
              strokeWidth="2.24605"
            />
            <path
              d="M292.32 162.062C291.718 161.914 291.11 162.281 290.961 162.884C290.813 163.486 291.181 164.094 291.783 164.243L292.32 162.062ZM301.611 166.666C302.214 166.814 302.822 166.446 302.971 165.844C303.119 165.242 302.751 164.633 302.149 164.485L301.611 166.666ZM291.783 164.243L301.611 166.666L302.149 164.485L292.32 162.062L291.783 164.243Z"
              fill="#211249"
            />
            <path
              d="M244.408 164.92L258.016 168.512"
              stroke="#211249"
              strokeWidth="2.24605"
              strokeLinecap="round"
            />
            <path
              d="M274.583 172.775L299.337 178.467"
              stroke="#211249"
              strokeWidth="2.24605"
              strokeLinecap="round"
            />
            <path
              d="M28 211.666C37.1345 207.352 59.3691 198.997 75.2327 200.099C77.482 200.191 80.8786 201.146 76.472 204.23C72.0655 207.315 69.8622 208.912 69.3114 209.325C67.0164 211.253 64.7671 215.33 74.131 216.211C85.8359 217.312 118.884 205.332 184.294 214.145"
              stroke="#211249"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <radialGradient
              id="paint0_radial_324_27934"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(180 250) rotate(-90) scale(61.1979 180)"
            >
              <stop stopColor="#F3F3FC" />
              <stop offset="1" stopColor="white" />
            </radialGradient>
          </defs>
        </svg>

        {description && <div className="tw-text-center tw-mt-4">{description}</div>}
      </div>
    </div>
  );
}

interface Props {
  className?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  description?: React.ReactNode;
}
